define('fukit/view/block/attached.container.view',['require','exports','module','uikit/uikit'],function(require, exports, module) {
  var UIKit = require('uikit/uikit');

  var AttachedComponentsContainerView = UIKit.ComponentsContainerView.extend({
    initialize: function() {
      UIKit.ComponentsContainerView.prototype.initialize.apply(this, arguments);
      this.once('render', function() {
        this.applyAttachedProperty();
        this.on('add:child remove:child', this.applyAttachedProperty);
      });
    },

    applyAttachedProperty: function() {
      this.children.each(function(child, index, list) {
        if (index === 0) {
          child.attached = 'top';
        } else if (index == list.length - 1) {
          child.attached = 'bottom';
        } else {
          child.attached = true;
        }
      });
    },
  });

  module.exports = AttachedComponentsContainerView;
});

